import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@material-ui/core";
import { ValidatorForm } from "react-material-ui-form-validator";
import { setActiveStep } from "../../../actions/recetasDigitales/RecetasDigitales";
import { STEPPER_RECETAS, TIPOS_RECETAS } from "../../../utils/constants";
import { RecetasDigitalesAccordionDiagnostico } from "./Accordions/RecetasDigitalesAccordionDiagnostico";
import {
  postReceta,
  setShowForm,
} from "../../../actions/recetasDigitales/RecetasDigitales";
import { startAlerta } from "../../../actions/ui/alertas";
import { RecetasDigitalesAccordionIndicacionesMedicas } from "./Accordions/RecetasDigitalesAccordionIndicacionesMedicas";
import { RecetasDigitalesAccordionPrescripciones } from "./Accordions/RecetasDigitalesAccordionPrescripciones";

export const RecetasDigitalesDetalleOrdenInformation = (props) => {
  const dispatch = useDispatch();
  const [datosCompletosDiagnostico, setDatosCompletosDiagnostico] =
    useState(true);
  const [datosCompletosIndicaciones, setDatosCompletosIndicaciones] =
    useState(false);
  const [datosCompletosPrescripcion, setDatosCompletosPrescripcion] =
    useState(false);
  const { recetaSeleccionada } = useSelector(
    (state) => state.recetasDigitales
  );

  const submitHandler = () => {
    if (recetaSeleccionada.idTipoReceta === TIPOS_RECETAS.PRESCRIPCION) {
      if (datosCompletosPrescripcion) {
        dispatch(postReceta(recetaSeleccionada, null, null, false));
        dispatch(setActiveStep(STEPPER_RECETAS.CONFIRMACION));
      } else {
        dispatch(
          startAlerta(
            "Debe completar la Prescripcion",
            "error",
            "Error"
          )
        );
      }
    } else {
      //if (datosCompletosDiagnostico) {
        dispatch(postReceta(recetaSeleccionada, null, null, false));
        dispatch(setActiveStep(STEPPER_RECETAS.MEDICAMENTOS));
      /*} else {
        dispatch(
          startAlerta(
            "Debe completar el diagnóstico",
            "error",
            "Error"
          )
        );
      }*/
    }

  };

  return (
    <React.Fragment>
      <ValidatorForm onSubmit={submitHandler}>
        {recetaSeleccionada.idTipoReceta !== TIPOS_RECETAS.PRESCRIPCION &&
          <RecetasDigitalesAccordionDiagnostico
            datosCompletos={datosCompletosDiagnostico}
            setDatosCompletos={setDatosCompletosDiagnostico}
          />}
        {recetaSeleccionada.idTipoReceta !== TIPOS_RECETAS.PRESCRIPCION &&
          <RecetasDigitalesAccordionIndicacionesMedicas
            datosCompletos={datosCompletosIndicaciones}
            setDatosCompletos={setDatosCompletosIndicaciones}
          />}
        {recetaSeleccionada.idTipoReceta === TIPOS_RECETAS.PRESCRIPCION &&
          <RecetasDigitalesAccordionPrescripciones
            datosCompletos={datosCompletosPrescripcion}
            setDatosCompletos={setDatosCompletosPrescripcion}
          />}
        <div
          style={{ display: "flex", justifyContent: "center", margin: "2rem" }}
        >
          <Button
            variant="contained"
            color="secondary"
            style={{ marginRight: "3rem" }}
            onClick={() => {
              dispatch(setShowForm(true));
            }}
          >
            Anterior
          </Button>
          <Button variant="contained" color="primary" type="submit">
            Siguiente
          </Button>
        </div>
      </ValidatorForm>
    </React.Fragment>
  );
};
